// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._flex-container_ffbb7,._flex_ffbb7{display:-ms-flexbox;display:flex}._flex-gap_ffbb7{--gap:0px;--column-gap:var(--gap);--row-gap:var(--gap);margin:calc(var(--row-gap) / -2) calc(var(--column-gap) / -2);width:calc(100% + var(--column-gap) + 1px);height:calc(100% + var(--row-gap))}._flex-container_ffbb7 ._flex-gap_ffbb7>*{margin:calc(var(--row-gap) / 2) calc(var(--column-gap) / 2)}\n", ""]);
// Exports
module.exports = exports;
